/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { KTIcon } from "../../../../_theme/helpers/components/KTIcon";
import { useLeftStepper } from "../../../../_theme/context/LeftStepperContext";
import { useAiAssistant } from "../../../../_theme/context/AiAssistantContext";

export const HideStepperButton: React.FC = () => {
  const { toggleLeftStepper, leftStepperHide, handleLeftStepperHide } = useLeftStepper();
  const { isOpen } = useAiAssistant();

  useEffect(() => {
    if (isOpen) {
      handleLeftStepperHide(true);
    } else {
      handleLeftStepperHide(false);
    }
  }, [isOpen]);
  
  return (
    <button
      onClick={toggleLeftStepper}
      type="button"
      className="btn btn-sm btn-light-primary mb-3 p-2"

    >
      <KTIcon iconName={leftStepperHide ? "right" : "left"} className="fs-3 m-0" />
    </button>
  );
};